import { render } from "./SelectTableColumn.vue?vue&type=template&id=16e37dc2&scoped=true"
import script from "./SelectTableColumn.vue?vue&type=script&lang=js"
export * from "./SelectTableColumn.vue?vue&type=script&lang=js"

import "./SelectTableColumn.vue?vue&type=style&index=0&id=16e37dc2&scoped=true&lang=css"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e37dc2"]])

export default __exports__